module.exports = __webpack_public_path__ + "media/images/user_video_symbolic-fec6faa72cb869dcbdc811ddb747181a.jpeg";